import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../../Styles/PageStyles";
import Images from "../../../Images";
import tw from "tailwind-styled-components";
import { PaginationLimit } from "../../../Config";
import Config from "../../../Config";

import { IoCopySharp } from "react-icons/io5";
import moment from "moment";
import { capitalizeFirstLetter, handleCopy, truncateText } from "../../../helpers";
import { MdOutlineChevronRight } from "react-icons/md";

const Table = ({
    apiData,
    setSelectedData,
    setShowViewDetails,
}) => {
    const storageKey = `property_list_page`;
    const [data, setData] = useState([
        {
            propName: "",
            address: "",
            createdAt: "",
            action: "",
        },
    ]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
    const [openActionMenu, setOpenActionMenu] = useState(null);

    // Load saved page index
    const storageValue = sessionStorage.getItem(storageKey);
    const savedPage = storageValue !== null ? Number(storageValue) : 0;
    const [currentPage, setCurrentPage] = useState(savedPage);
    useEffect(() => {
        setCurrentPage(savedPage);
    }, [savedPage]);

    const toggleRow = (index) => {
        setSelectedRow(selectedRow === index ? null : index);
    };
    const viewDetails = (item) => {
        setSelectedData(item);
        setShowViewDetails(true);
    };

    const ActionBtns = (item) => {
        return (
            <div className="flex gap-4 ">
                <button
                    onClick={() => viewDetails(item)}
                    className={`cursor-pointer text-sm px-4 py-1 rounded-lg ${' text-gray-600'} flex items-center gap-1`}
                >
                    <MdOutlineChevronRight className="text-gray-300" size={24} />
                </button>
            </div>
        );
    };

    const getCollections = (item) => {
        return (
            <div className="flex flex-col gap-1">
                <span className="text-gray-600 text-sm block max-w-[160px] break-words line-clamp-2">
                    {'₹' + (item?.totalCollection || 0)}
                </span>
                <div className="flex items-center gap-2">
                    <span className="text-gray-400 text-xs">Security: {'₹' + (item?.totalSecurityCollection || 0)}</span>
                </div>
            </div>
        );
    };

    const getPropName = (item) => {
        const name = capitalizeFirstLetter(item?.name || 'N/A');
        return (
            <div className="flex flex-col gap-1">
                <span className="text-gray-600 text-sm block max-w-[160px] break-words line-clamp-2">
                    {truncateText(name || 'N/A', 30)}
                </span>
                <div className="flex items-center gap-2">
                    <span className="text-gray-400 text-xs">ID: {item.gId || 'N/A'}</span>
                    <button onClick={(e) => {
                        e.stopPropagation();
                        handleCopy(item.gId);
                    }}>
                        <IoCopySharp size={10} className="text-gray-400" />
                    </button>
                </div>
            </div>
        );
    };

    const getPrimaryTenant = (item) => {
        return (
            <div className="flex flex-col gap-1">
                <span className="text-gray-600 text-sm ">
                    {truncateText(item.ownerName || 'N/A', 20)}
                </span>
                <span className="text-gray-400 text-xs">
                    {'#' + item.ownerMobile}
                </span>
            </div>
        );
    };

    const getAddress = (item) => {
        return (
            <div className="flex flex-col gap-1">
                <span className="text-gray-600 text-sm ">
                    {truncateText(item.streetAddress || 'N/A', 40)}
                </span>
                <span className="text-gray-400 text-xs">
                    {item.address ? truncateText(item.address, 50) : 'Address not available'}
                </span>
            </div>
        );
    };

    const getTenantPreference = (item) => {
        const preferences = {
            1: 'Male',
            2: 'Female',
            3: 'Both',
        };

        return (
            <div className="flex items-center gap-2">
                <span className="text-gray-600 text-sm bg-neutral-100 px-3 py-1 rounded-md">
                    {preferences[item.tenantPreference] || 'Not specified'}
                </span>
            </div>
        );
    };

    const getAgreementInfo = (item) => {
        return (
            <div className="flex gap-3 ">
                <div className="flex flex-col text-sm text-gray-600">
                    <span>
                        {item.startDate
                            ? moment(item.startDate).format("DD, MMM YY")
                            : "-"}
                        {' - '}
                        {item.endDate
                            ? moment(item.endDate).format("DD, MMM YY")
                            : "-"}
                    </span>
                </div>
            </div>
        );
    };

    const getStatus = (item) => {
        if (item.status === 1) {
            return <Pending>Pending</Pending>;
        }
        else if (item.status === Config.PROPERTY_STATUS.ACTIVE) {
            return <Active>Active</Active>;
        } else {
            return <Inactive>Inactive</Inactive>;
        }
    };

    useEffect(() => {
        if (apiData) {
            const tempData = apiData.map((item) => ({
                propName: getPropName(item),
                address: getAddress(item),
                rent: '₹' + (item?.leaseRent || 0),
                primaryTenant: getPrimaryTenant(item),
                agreement: getAgreementInfo(item),
                tenantPreference: getTenantPreference(item),
                status: getStatus(item),
                dues: getDuesAmount(item),
                collections: getCollections(item),
                createdAt: moment(item.createdAt).format('DD, MMM YYYY'),
                action: ActionBtns(item),
            }));
            setData(tempData);
        }
    }, [apiData, openActionMenu]);

    const getDuesAmount = (item) => {
        return (
            <Amount>{'₹' + (item?.pendingDues || 0)}</Amount>
        );
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                !event.target.closest("#menuOptions") &&
                !event.target.closest(".action-btn")
            ) {
                setOpenActionMenu(null);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const columns = React.useMemo(() => {
        if (isMobileView) {
            return [
                {
                    Header: "Property Name",
                    accessor: "propName",
                },
                {
                    Header: "Address",
                    accessor: "address",
                },
            ];
        }
        return [
            {
                Header: "Name",
                accessor: "propName",
            },
            // {
            //     Header: "Address",
            //     accessor: "address",
            // },
            {
                Header: "Primary Tenant",
                accessor: "primaryTenant",
            },
            {
                Header: "Total Collected",
                accessor: "collections",
            },
            {
                Header: "Rent",
                accessor: "rent",
            },
            {
                Header: "Dues",
                accessor: "dues",
            },
            // {
            //     Header: "Agmt Duration",
            //     accessor: "agreement",
            // },
            {
                Header: "Status",
                accessor: "status",
            },
            // {
            //     Header: "Created At",
            //     accessor: "createdAt",
            // },
            {
                Header: "",
                accessor: "action",
            },
        ];
    }, [isMobileView]);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        pageOptions,
        page,
        state: { pageIndex },
        previousPage,
        nextPage,
        canPreviousPage,
        canNextPage,
    } = useTable(
        {
            data,
            columns,
            initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
        },
        useSortBy,
        usePagination
    );

    useEffect(() => {
        sessionStorage.setItem(storageKey, pageIndex);
    }, [pageIndex, storageKey]);

    return (
        <>
            <CustomTable {...getTableProps()}>
                <Thead>
                    {headerGroups.map((headerGroup) => (
                        <Tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                    {column.render("Header")}
                                    <span>
                                        {column.isSorted ? (
                                            <img
                                                src={Images.Arrow}
                                                alt="down arrow"
                                                className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                                                    } w-1.5 inline-block ml-1.5`}
                                            />
                                        ) : (
                                            ""
                                        )}
                                    </span>
                                </Th>
                            ))}
                        </Tr>
                    ))}
                </Thead>
                <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
                    {page.map((row, rowIndex) => {
                        prepareRow(row);
                        const rowData = apiData[rowIndex];
                        return (
                            <React.Fragment key={rowIndex}>
                                <Tr
                                    {...row.getRowProps({ style: { height: "80px" } })}
                                    hasdata={(apiData?.length > 0).toString()}
                                >
                                    {row.cells.map((cell, cellIndex) => {
                                        return (
                                            <Td
                                                {...cell.getCellProps()}
                                                onClick={() => {
                                                    if (
                                                        cellIndex === 0 ||
                                                        (cellIndex === 1 && window.innerWidth < 768)
                                                    ) {
                                                        toggleRow(rowIndex);
                                                    }
                                                }}
                                            >
                                                {cell.render("Cell")}
                                            </Td>
                                        );
                                    })}
                                </Tr>
                                {selectedRow === rowIndex && window.innerWidth < 768 && (
                                    <Tr>
                                        <Td colSpan={columns.length}>
                                            <ul className="flex flex-col gap-2">
                                                <li>
                                                    <strong>Tenant Preference</strong>{" "}
                                                    {data[rowIndex].tenantPreference}
                                                </li>
                                                <li>
                                                    <strong>Created At</strong>{" "}
                                                    {data[rowIndex].createdAt}
                                                </li>
                                                <li>
                                                    <strong>Action</strong>{" "}
                                                    {data[rowIndex].action}
                                                </li>
                                            </ul>
                                        </Td>
                                    </Tr>
                                )}
                            </React.Fragment>
                        );
                    })}
                </Tbody>
            </CustomTable>
            {apiData?.length > 0 && (
                <PaginationWrapper>
                    <div className="px-2">
                        Page{" "}
                        <em>
                            {pageIndex + 1} of {pageOptions.length}
                        </em>
                    </div>

                    <div className="flex gap-1">
                        <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
                            <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
                        </PrevBtn>
                        <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
                            <img
                                src={Images.Arrow}
                                alt="arrow"
                                className="w-2 rotate-180 opacity-75"
                            />
                        </NextBtn>
                    </div>
                </PaginationWrapper>
            )}
        </>
    );
};

const CustomTable = tw.table` w-full text-gray-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
    props.hasdata === "true"
        ? "border-b"
        : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const Active = tw.div`font-semibold text-green-500 text-xs`;
const Pending = tw.div`font-semibold text-blue-500 text-xs`;
const Inactive = tw.div`font-semibold text-red-500 text-xs`;
const Amount = tw.p`text-gray-600 text-sm bg-rose-100 px-3 py-1 rounded-md inline-flex`
export default Table;